import { BottomSheetModal } from '@gorhom/bottom-sheet';
import { RefObject, useState } from 'react';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';

export default function useRequestLocation(
  bottomSheetRef: RefObject<BottomSheetModal | null> | null,
  onLocation: (location: GeolocationPosition) => unknown,
  onDeniedLocation: (error?: GeolocationPositionError) => unknown,
) {
  const LOCATION_PERMISSION_TIMEOUT = 10000;
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  const locationRequestTrackEvent = usePressableAnalytics({
    analyticsId: 'locationRequested',
  });

  const requestLocation = async () => {
    if ('geolocation' in navigator && 'permissions' in navigator) {
      // navigator.geolocation.getCurrentPosition(onLocation, onDeniedLocation);
      const permissions = await navigator.permissions.query({
        name: 'geolocation',
      });

      if (permissions.state === 'granted') {
        // We are good to go and have location
        navigator.geolocation.getCurrentPosition(onLocation, null, {
          enableHighAccuracy: true,
          timeout: LOCATION_PERMISSION_TIMEOUT,
          maximumAge: 0,
        });

        return;
      } else if (permissions.state === 'prompt') {
        // We don't have location, but we can ask for it
        setIsBottomSheetOpen(true);
        bottomSheetRef?.current?.present();
        locationRequestTrackEvent();
        return;
      }

      // We can't ask for location again, bummer
      onDeniedLocation();
      setIsBottomSheetOpen(false);
      bottomSheetRef?.current?.dismiss();
    }
  };
  const requestLocationPermission = () => {
    navigator.geolocation.getCurrentPosition(onLocation, onDeniedLocation, {
      enableHighAccuracy: true,
      timeout: LOCATION_PERMISSION_TIMEOUT,
      maximumAge: 0,
    });

    bottomSheetRef?.current?.dismiss();
    setIsBottomSheetOpen(false);
  };

  return { requestLocation, requestLocationPermission, isBottomSheetOpen };
}
